import product from "../data/product"

const translations = {
    it: {
        // GENERAL ----------------------------------------------------------------------------------
        artists: "Artisti",
        aboutUs: "Storia",
        products: "Prodotti",
        discover: "Scopri",

        // HOME ----------------------------------------------------------------------------------

        landing_heroCaption1: "BE THE",
        landing_heroCaption2: "VIBE",
        landing_ProductsSubtitle: "Ogni capo un glitch. Indossa chi sei",
        landing_viewCollection: "SCOPRI LA COLLEZIONE",
        landing_brandStoryDescription: "Costruiamo spazi che gli artisti sono invitati a riempire. Un'estetica urbana che non rappresenta un trend ma racconta chi la indossa. Il resto è rumore",
        
        landing_artists: "ARTISTI",
        landing_aboutUs: "STORIA",
        landing_products: "PRODOTTI",
        landing_artistsDescription: "Dietro ogni capo un tratto riconoscibile",
        landing_aboutUsDescription: "Il percorso verso la frequenza che cerchiamo",
        landing_productsDescription: "Le vibe giusta esiste. Scoprila in collezione",
        
        landing_copyright: "Tutti i diritti riservati.",

        // STORY ----------------------------------------------------------------------------------

        about_description1: `<b>La storia finora</b>\n\nDtune nasce nel <b>2025</b> tra i palazzi della periferia nord-ovest di Milano. Iniziativa di un Artificial Intelligence Engineer che ha scelto di realizzare <b>capi unici</b> in dialogo con <b>artisti emergenti</b>.
        
        Persone con un tratto riconoscibile, non replicabile.

        Una <b>dimensione collettiva</b> possibile anche grazie al contributo di amici che hanno deciso di sostenere il progetto mettendo a disposizione competenze e idee.
        Desiderio di costruire uno spazio in cui tecnologia e innovazione fanno la differenza poiché strumento a sostegno delle capacità creative. Dtune diventa così un <b>glitch</b> attraverso il quale gli illustratori realizzano qualcosa che cattura anche offline: un brand di abbigliamento <b>urban</b> che permette a chiunque di valorizzare la propria identità.

        Dtune crede nelle melodie sorprendenti nate da note fuori scala, rottura della monotonia come atto di <b>resistenza creativa</b>: restituzione del potere di definire chi siamo all’essere umano.
        `,
        about_description2: `<b>Fatto da Noi</b>\n\nT-shirt pensate come narrazioni:

        • <b>Creatività 100% Umana</b>:  Collaboriamo con artisti che realizzano grafiche <b>custom</b> nate esclusivamente dall’ingegno umano.
        • <b>Mascotte</b>: Gli animali delle illustrazioni sono <b>daimon</b> che accompagnano nella quotidianità suggerendo cambiamenti di prospettiva, a partire dal fronte e retro delle magliette.
        • <b>Oltre le grafiche</b>: Dtune è portavoce di talento, offre agli artisti uno spazio dove è possibile <b>condividere prospettive</b> e portfolio personale. L’obiettivo è creare relazioni tra chi indossa le opere e coloro che le hanno realizzate.
        `,
        about_description3: `Scegliere Dtune significa sostenere un ecosistema dove l'artista non è un fornitore anonimo, ma firma riconosciuta con una <b>visione autentica</b>. È credere nella creatività che risiede ancora nelle persone capaci di immaginare.
        `,

        about_footer: "STREET • CREATIVE • AUTHENTIC",
        about_contact_us_label: "Siamo qui",
        about_contact_us_description: "Contattaci quando vuoi",
        
        // PRODUCTS ----------------------------------------------------------------------------------

        products_subtitle: "100% cotone morbido. Oversized. Unisex.",

        discover_description: "Scegliere <b>Dtune</b> significa sostenere un ecosistema dove l'artista non è un fornitore anonimo, ma firma riconosciuta con una visione autentica. È credere nella creatività che risiede ancora nelle persone capaci di immaginare.",
        discover_call2action: "Se qualcosa ti ha colpito o vuoi sapere di più su quello che facciamo, siamo a un <b>click</b> di distanza. <b>Scrivici via email o sui nostri canali</b>!",

        // PRODUCT_DETAIL ----------------------------------------------------------------------------------
        
        product_detail_designed_with: "realizzato con",
        product_detail_availability: "Disponibilità",
        product_detail_discover: "SCOPRI ORA",
        product_detail_size: "Taglia (cm)",
        product_detail_height: "Altezza",
        product_detail_length: "Lunghezza",
        product_detail_gallery_zoom: "Ingrandisci",
        product_detail_gallery_zoom_out: "Riduci",
        product_detail_gallery_close: "Chiudi",
        product_detail_gallery_prev: "Precedente",
        product_detail_gallery_next: "Successiva",

        // ARTISTS ----------------------------------------------------------------------------------

        artists_action_view: "SCOPRI"

    
    },
    en: {
        // GENERAL ----------------------------------------------------------------------------------
        artists: "Artists",
        aboutUs: "Story",
        products: "Products",
        discover: "Discover",

        // HOME ----------------------------------------------------------------------------------

        landing_heroCaption1: "BE THE",
        landing_heroCaption2: "VIBE",
        landing_ProductsSubtitle: "An article, a glitch. Wear who you are",
        landing_viewCollection: "DISCOVER THE COLLECTION",
        landing_brandStoryDescription: "We create spaces that artists are invited to fill. An urban appearance which doen't represent a trend but tells about who wears it. The rest is noise",
           
        landing_artists: "ARTISTS",
        landing_aboutUs: "STORY",
        landing_products: "PRODUCTS",
        landing_artistsDescription: "Behind every item a recognizable trait",
        landing_aboutUsDescription: "The path towards the frequency we seek",
        landing_productsDescription: "The right vibe exists. Find it in the collection",
    
        landing_copyright: "All rights reserved.",

        // STORY ----------------------------------------------------------------------------------

       about_description1: `<b>The story so far</b>\n\nDtune was born in <b>2025</b> among north-west buildings of Milan outskirts. Initiative of an Artificial Intelligence Engineer who chose to create <b>unique pieces</b> of clothing in communication with <b>emerging artists</b>.
        
        People with a recognizable, non replicable trait.

        A <b>collective dimension</b> made possible thanks to the help of some friends who decided to contribute to the project with their skills and ideas.
        The desire to build a space in which technology and innovation make a difference, being a support of creative competence. Thus, Dtune becomes a <b>glitch</b> through which illustrators realize something that captures even offline: an <b>urban</b> clothing brand allowing anyone to give value to their identity.
        
        Dtune believes in the surprising melodies born from out-of-scale notes, a breaking from monotony as an act of <b>creative resistance</b>: returning power in defining our identity to the human being.
        `,
        about_description2: `<b>Made by us</b>\n\nT-shirts thought as stories:

        • <b>100% Human Creativity</b>:  We work together with artists realizing <b>custom</b> graphics born exclusively from human ingenuity.
        • <b>Mascotte</b>: The animals illustrated are <b>daimon</b> walking you in everyday life suggesting a change of perspective, starting from the front and back of the t-shirts.
        • <b>Beyond graphics</b>: Dtune is a spokesperson of talent, offering artists a space where <b>sharing points of view</b> and personal portfolios is possible. The goal is creating links between who is wearing them and who realized those.
        `,
        about_description3: `Choosing Dtune means supporting an ecosystem where the artist is not an anonymous provider, but rather a distinguished label with an <b>authentic vision</b>. It’s believing in the creativity still residing in people able to imagine.
        `,

        about_footer: "STREET • CREATIVE • AUTHENTIC",
        about_contact_us_label: "We are here",
        about_contact_us_description: "Get in touch anytime",
        
        // PRODUCTS ----------------------------------------------------------------------------------

        products_subtitle: "100% cotton soft touch. Oversized. Unisex.",

        discover_description: "Choosing <b>Dtune</b> means supporting an ecosystem where the artist is not an anonymous provider, but rather a distinguished label with an authentic vision. It’s believing in the creativity still residing in people able to imagine.",
        discover_call2action: "If something catches your eye or you want to know about what we do, we are just a <b>click</b> away. <b>Write us an email or get in contact through our channels</b>!",

        // PRODUCT_DETAIL ----------------------------------------------------------------------------------

        product_detail_designed_with: "designed with",
        product_detail_availability: "Availability",
        product_detail_discover: "DISCOVER",
        product_detail_size: "Size (cm)",
        product_detail_height: "Height",
        product_detail_length: "Length",
        product_detail_gallery_zoom: "Zoom in",
        product_detail_gallery_zoom_out: "Zoom out",
        product_detail_gallery_close: "Close",
        product_detail_gallery_prev: "Previous",
        product_detail_gallery_next: "Next",

        // ARTISTS ----------------------------------------------------------------------------------

        artists_action_view: "VIEW"
    }
}

export default translations